module.exports = __webpack_public_path__ + "img/bg-9.c604812f.jpg";